var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: { "hide-footer": "", title: "設定", size: "lg" }
        },
        [
          _c("div", { staticClass: "d-block text-center" }),
          _c("div", { staticClass: "form-group row" }, [
            _c("label", { staticClass: "col-sm-2", attrs: { for: "" } }, [
              _vm._v("表單連結")
            ]),
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c("MyInputCopyTextbox", {
                  model: {
                    value: _vm.formLink,
                    callback: function($$v) {
                      _vm.formLink = $$v
                    },
                    expression: "formLink"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "btn btn-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("關閉")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }